import React from 'react';
import { Box } from '@mui/material';
import ShopSection from '../components/ShopSection';

const ShopPage = () => {
  return (
    <Box sx={{ pt: 8 }}>
      <ShopSection />
    </Box>
  );
};

export default ShopPage;
